// Buybox visibility panes.
//
// Every buybox child block wraps its per-variant markup in
// <nss-buybox-pane nss-variant-id="…">. These elements are pure
// panes: they listen for buyboxUpdate and toggle nss-active so the markup for
// the selected variant shows and the rest hides. All buybox behavior (clicks,
// quantity, selling plans, prices, discount preview, URL sync, buyboxUpdate
// dispatch) lives in the per-buybox controller — see nss-buybox.js.
let elementName = `nss-buybox-pane`;
if (typeof customElements.get(elementName) === `undefined`) {
  class NSSBuyboxPane extends HTMLElement {
    constructor() {
      super();

      this.debug = false;
    }

    connectedCallback() {
      if (this.debug) console.log(`[NSS][Buybox Pane] Connected.`);

      this.variantId = this.getAttribute(`nss-variant-id`);
      this.addEventListener(`buyboxUpdate`, this.updateHandler.bind(this));
    }

    updateHandler(e) {
      const newId = e.detail.newId;

      // Scope coordination to this element's own buybox. The buyboxUpdate bus is
      // section-wide, so an unrelated buybox elsewhere on the page (a different
      // product, its own variant ids) would otherwise receive this event, match
      // nothing, and blank out permanently. Ignore updates for a variant that
      // isn't part of our local buybox's universe.
      const scope =
        this.closest(`nss-buybox`) || this.closest(`[id^="shopify-section"]`) || document;
      if (!scope.querySelector(`[nss-buybox-update][nss-variant-id="${newId}"]`)) {
        return;
      }

      if (newId === this.variantId) {
        this.classList.add(`nss-active`);
      } else {
        // Collapse an open frequency dropdown when this pane hides.
        const planMenu = this.querySelector(`[nss-plan-select]`);
        planMenu?.parentElement.classList.remove(`nss-active`);
        this.classList.remove(`nss-active`);
      }
    }
  }

  customElements.define(elementName, NSSBuyboxPane);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}

class NSSBuyboxBottom extends HTMLElement {
  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    this.variantId = this.getAttribute(`nss-variant-id`);
    this.addEventListener(`buyboxUpdate`, this.updateHandler.bind(this));
  }

  updateHandler(e) {
    const newId = e.detail.newId;

    // Scope coordination to this element's own buybox — see NSSBuyboxPane.
    // Bottom blocks (info-card/accordions) for a different product elsewhere on
    // the page must not blank when the main buybox switches flavors.
    const scope = this.closest(`nss-buybox`) || this.closest(`[id^="shopify-section"]`) || document;
    if (!scope.querySelector(`[nss-buybox-update][nss-variant-id="${newId}"]`)) {
      return;
    }

    if (newId === this.variantId) {
      this.classList.add(`nss-active`);
    } else {
      this.classList.remove(`nss-active`);
    }
  }
}

let elementName2 = `nss-buybox-bottom`;

if (typeof customElements.get(elementName2) === `undefined`) {
  customElements.define(elementName2, NSSBuyboxBottom);
}
